var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.766 0H3.23429C1.44821 0 0.000244141 1.44791 0.000244141 3.23405V20.7658C0.000244141 22.552 1.44815 23.9999 3.23429 23.9999H11.8808L11.8956 15.4236H9.66746C9.3779 15.4236 9.14288 15.1895 9.14176 14.8999L9.13108 12.1354C9.12996 11.8443 9.36569 11.6077 9.65683 11.6077H11.8809V8.93651C11.8809 5.83661 13.7741 4.14869 16.5394 4.14869H18.8086C19.0989 4.14869 19.3343 4.38406 19.3343 4.67444V7.00547C19.3343 7.29573 19.0991 7.53104 18.8089 7.53122L17.4163 7.53187C15.9125 7.53187 15.6212 8.24648 15.6212 9.29522V11.6078H18.9258C19.2406 11.6078 19.4849 11.8827 19.4478 12.1954L19.1201 14.9599C19.0888 15.2244 18.8645 15.4237 18.5981 15.4237H15.636L15.6212 24H20.7661C22.5522 24 24.0001 22.5521 24.0001 20.766V3.23405C24 1.44791 22.5521 0 20.766 0Z",
    fill: "#475993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.60421ba8.svg";
export { ForwardRef as ReactComponent };